<template>
  <div class="wrapper">
    <h1
      v-t="'p.pageNotFound.title'"
      class="reset-margin"
    />
    <span v-t="'p.pageNotFound.message.pageNotFound'" />
  </div>
</template>

<script>
export default {
  created () {
    this.$emit('loadingDone')
  }
}
</script>

<style lang="sass" scoped>
  .wrapper
    text-align: center
    padding: 200px 0
</style>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue